export default __webpack_public_path__ + "static/media/generic-loader@2x.858d2400.gif";